<div class="header container">
  <h3>Vous n'êtes pas authorisé à voir ce contenu</h3>
</div>
